import { SessionService } from './SessionService';
import { environment } from './../../environments/environment';
import { ErrorHandler } from './../common/error/error-handler';
import { TrainingSession } from './../model/training-session';
import { Site } from './../model/site';
import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestOptions, Headers } from '@angular/http';
import { UserNode } from '../model/user-node';
import { Session } from 'protractor';
import {_} from 'underscore';
import 'rxjs/add/operator/catch';
import {UserNodeBuilder} from '../model/builder/user-node.builder';
import { HierarchyService } from './hierarchy.service';

@Injectable()
export class TrainingService {

  private url: string;

  constructor(private http: HttpClient, private hierarchyService: HierarchyService, private session: SessionService) {
   this.url = environment.api.myformationUrl + '/trainingTimesheets/training';
   // this.url = 'http://172.19.46.28:3006/trainingTimesheets/training';
  }

  loadHierarchy() {
    return this.http.get(this.url)
        .map(response => response);
  }

  getAllSiteMembers(site: Site): UserNode[] {
    const members = [];
    site.sessions.forEach(session => {
      session.trainingSessionAssignmentList.forEach(trainingSessionAssignment => {
        members.push(trainingSessionAssignment.user);
      });
    });
    return members;
  }

  getAllSessionMembers(trainingSession: TrainingSession): UserNode[] {
    const members = [];
    trainingSession.trainingSessionAssignmentList.forEach(trainingSessionAssignment => {
      members.push(trainingSessionAssignment.user);
    });
    return members;
  }

  getAllMembersFromNode(sites: Site[], nodeId: number): UserNode[] {
    for (const site of sites) {
      if (site.id === nodeId) {
        return this.getAllSiteMembers(site);
      }
      for (const session of site.sessions) {
        if (session.id === nodeId) {
          return this.getAllSessionMembers(session);
        }
        for (const trainingSessionAssignment of session.trainingSessionAssignmentList) {
          if (trainingSessionAssignment.user.id === nodeId) {
            return [trainingSessionAssignment.user];
          }
        }
      }
      for (const sitelinkeduser of site.sitelinkedusers) {
        if (sitelinkeduser.id === nodeId) {
          return [sitelinkeduser];
        }
      }
    }
    return [];
  }

  buildTree(sites: Site[], query?: string) {
    sites = [... this.hierarchyService.getUnifiedNodes(sites)]
    const nodes = [];
    _.each(sites, (s, i) => {
      nodes.push({id: s.id, name: s.nom, icon: 'keyboard_arrow_right', siteName: s.nom, teamName: null, agentName: null, class: "sites_list"});
      _.each(s.sessions, (t, e) => {
        let users = [];
        t.trainingSessionAssignmentList.forEach(tsa => users.push(this.buildUser(tsa.user, tsa.dateDebut, tsa.dateFin)));
        nodes.push({id: t.id, name: t.name, parent: s.id, icon: 'supervisor_account', siteName: s.nom, teamName: t.name,
          agentName: null, users: users, class: "teams_list"});
        _.each(users, (u, o) => {
          nodes.push({id: u.id, name: this.buildUserNameNode(u), parent: t.id, icon: 'person', siteName: s.nom, teamName: t.name,
            agentName: this.buildUserNameNode(u), users: [u], periods: [{start: null, end: null}], class: 'persons_list'});
        });
      });
    });
    return nodes;
  }

  buildUserNameNode(user: UserNode) {
    return user.firstName + ' ' + user.lastName + ' [' + user.username + ']';
  }

  buildUser(user: UserNode, dateDebut, dateFin) {
    user.periods = [{start: dateDebut, end: dateFin}]
    return user;
  }


  isUserFiltered(user: UserNode, query: string): boolean {
    query = query.toLowerCase();
    const name = user.firstName.toLowerCase() + ' ' + user.lastName.toLowerCase();
    return user.firstName.toLowerCase().includes(query) ||
        user.lastName.toLowerCase().includes(query) ||
        user.username.toString().toLowerCase().includes(query) ||
        name.includes(query);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/training.service.ts